
import React from 'react';
import cn from 'classnames';

import styles from './Layout.module.scss';
import { useState} from 'react';



export default function Layout(props) {

 



  return (
    <div className={cn(styles.cover_block, styles.cover_block_layout)}>
      <div className={cn(styles.flex3, styles.flex3_layout)}>
        <div className={cn(styles.flex4, styles.flex4_layout)}>
          <div className={cn(styles.flex4_item)}>
            <div className={cn(styles.block9, styles.block9_layout)}>
            {props.data.totalSlots}
            </div>
          </div>
          <div className={cn(styles.flex4_spacer)} />
          <div className={cn(styles.flex4_item1)}>
            <div className={cn(styles.paragraph_body, styles.paragraph_body_layout)}>
            {"Swap Station"+'\n'+props.data.name}
            </div>
          </div>
          <div className={cn(styles.flex4_spacer1)} />
          <div className={cn(styles.mediam_text_body1, styles.small_text_body1_layout)}>
          {props.data.temperature}
          <span className={cn(styles.mediam_text_body1, styles.mediam_text_body1_layout)} >℃</span>
          </div>
        </div>

        <hr className={cn(styles.line1, styles.line1_layout)} />

        <div className={cn(styles.flex5, styles.flex5_layout)}>
          <div className={cn(styles.small_text_body, styles.small_text_body_layout)}>
            {'Available'}
          </div>
          <div className={cn(styles.flex5_spacer)} />
          <div className={cn(styles.flex5_item)}>
            <div className={cn(styles.block8, styles.block8_layout)}>
            {props.data.availableSlots}

              
            </div>
          </div>
        </div>

        <div className={cn(styles.flex6, styles.flex6_layout)}>
          <div className={cn(styles.small_text_body, styles.small_text_body_layout)}>
            {'Charging'}
          </div>
          <div className={cn(styles.flex5_spacer)} />
          <div className={cn(styles.flex5_item)}>
            <div className={cn(styles.block10, styles.block10_layout)}>
            {props.data.occupiedSlots}

              
            </div>
          </div>
        </div>

        <div className={cn(styles.flex6, styles.flex6_layout)}>
          <div className={cn(styles.small_text_body, styles.small_text_body_layout)}>
            {'Faulted'}
          </div>
          <div className={cn(styles.flex5_spacer)} />
          <div className={cn(styles.flex5_item)}>
            <div className={cn(styles.block11, styles.block11_layout)}>
            {props.data.faultySlots}

              
            </div>
          </div>
        </div>

        <hr className={cn(styles.line2, styles.line2_layout)} />

        <div className={cn(styles.flex7, styles.flex7_layout)}>
          <div className={cn(styles.small_text_body, styles.small_text_body_layout)}>
            {'No of Swaps'}
          </div>
          <div className={cn(styles.flex6_spacer)} />
          <div className={cn(styles.small_text_body, styles.small_text_body_layout2)}>
          {props.data.swaps}
          </div>
        </div>
      </div>
    </div>
  );
}
